<template>
  <div class="tblFilterHesabCode">
    <div class="table-respon" style="max-height: 140px; overflow-y: auto">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead>
          <td class="bg-primary-light">کد حساب</td>
          <td class="bg-primary-light">عنوان حساب ({{ TbBaseAccDataFilter.length }} مورد)</td>
        </thead>
        <tbody>
          <tr
            v-for="row in TbBaseAccDataFilter"
            :key="row.NCode"
            v-on:click="selectRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
            v-on:dblclick="dblClickRow(row.NCode, row.SDesc, row.NAccType, row.NPerID)"
            v-bind:id="'rowFilter-' + row.NCode"
            :class="{ selRow: selectRowID == row.NCode }"
            style="cursor: pointer;"
          >
            <td>{{ row.NCode }}</td>
            <td>{{ row.SDesc }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row h8 text-secondary mt-2 d-flex justify-content-center align-items-center">راهنما : فلش <i class="fas fa-long-arrow-alt-up px-1"></i> و <i class="fas fa-long-arrow-alt-down px-1"></i> حرکت بین سطرها ، F4 انتخاب</div>
  </div>
</template>

<script>
import { BusEvent } from "../../../../../../main.js";

export default {
  name: "FilterHesabCode",
  data() {
    return {
      TbBaseAccData: [],
      TbBaseAccDataFilter: [],

      selectRowID: 0,
      selectRowType: 0,
      selectRowSDesc: "",
      selectRowNPerID: 0
    };
  },
  props: ["HesabCode","levelNumber"],
  watch: {
    HesabCode: function (value) {
      this.filterTbBaseAccData(value);
    },
    levelNumber: function (value) {
      this.getTbBaseAccData(value);
    }
  },
  created() {
    //alert('create Filter');
    this.getTbBaseAccData(this.levelNumber);
    BusEvent.$on("keyPressValue", this.hotKeyChecker);
  },
  beforeDestroy() {
    //alert('Destroy Filter');
    BusEvent.$off("keyPressValue", this.hotKeyChecker);
  },
  methods: {
    getTbBaseAccData(levelnumber) {
      this.TbBaseAccData = this.$store.getters.getAllTbBaseAccData;
      if(this.TbBaseAccData.length > 0){
        this.TbBaseAccData = this.TbBaseAccData.filter(function(tb){
          return tb.NCode.toString().length == levelnumber;
        });
      }
      this.TbBaseAccDataFilter = this.TbBaseAccData;
    },

    filterTbBaseAccData(NCode) {
      console.log('NCode : ' + NCode);
      this.TbBaseAccDataFilter = this.TbBaseAccData.filter(function (t) {
        return t.NCode.startsWith(NCode);
      });
    },

    dblClickRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRow(NCode, SDesc, NAccType, NPerID);
      this.SelectHesab();
    },

    selectRow(NCode, SDesc, NAccType, NPerID) {
      this.selectRowID = NCode;
      this.selectRowSDesc = SDesc;
      this.selectRowType = NAccType;
      this.selectRowNPerID = NPerID;
    },

    SelectHesab() {
      if (this.selectRowID == 0) {
        this.$store.dispatch(
          "notify",
          "حسابی در حالت انتخاب نیست !\nلطفا ابتدا یکی از حساب ها را در حالت انتخاب قرار دهید ."
        );
      } else {
        this.$emit("HideFilterHesab", {
          NCode: this.selectRowID,
          SDesc: this.selectRowSDesc,
          NAccType: this.selectRowType,
          NPerID: this.selectRowNPerID
        });
      }
    },

    // تابع مدیریت کلید میانبرها داخل سند
    hotKeyChecker(keyvalue) {
      //alert('filter hesab : ' + keyvalue.key);
      if (this.TbBaseAccDataFilter.length > 0) {
        if (keyvalue.key === "ArrowUp" || keyvalue.key === "ArrowDown") {
          let index = this.TbBaseAccDataFilter.findIndex(
            (itme) => itme.NCode == this.selectRowID
          );
          if (index != -1) {
            if (keyvalue.key === "ArrowUp") {
              if (index > 0) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index - 1].NCode,
                  this.TbBaseAccDataFilter[index - 1].SDesc,
                  this.TbBaseAccDataFilter[index - 1].NAccType,
                  this.TbBaseAccDataFilter[index - 1].NPerID
                );
                $(
                  "#rowFilter-" + this.TbBaseAccDataFilter[index - 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            } else {
              if (index + 1 < this.TbBaseAccDataFilter.length) {
                this.selectRow(
                  this.TbBaseAccDataFilter[index + 1].NCode,
                  this.TbBaseAccDataFilter[index + 1].SDesc,
                  this.TbBaseAccDataFilter[index + 1].NAccType,
                  this.TbBaseAccDataFilter[index + 1].NPerID
                );
                $(
                  "#rowFilter-" + this.TbBaseAccDataFilter[index + 1].NCode
                ).scrollintoview({
                  duration: 100,
                  //complete: this.$store.dispatch("notify", "تست نمایش پیام"),
                });
              }
            }
          } else {
            this.selectRow(
              this.TbBaseAccDataFilter[0].NCode,
              this.TbBaseAccDataFilter[0].SDesc,
              this.TbBaseAccDataFilter[0].NAccType,
              this.TbBaseAccDataFilter[0].NPerID
            );
          }
        }
        // انتخاب سطر و بستن پنجره
        if (keyvalue.key === "F4" || keyvalue.key === "Enter") {
          this.SelectHesab();
        }
      }
    },
  },
};
</script>

<style scoped>
.tblFilterHesabCode {
  position: absolute;
  background-color: #fee3e8;
  width: 300px;
  min-height: 80px;
  max-height: 170px;
  margin-top: 35px;
  z-index: 99999;
  /* top: 52px; */
  padding: 5px;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 40%) 0px 0px 5px;
}

.tblFilterHesabCode table {
  background-color: white;
}

.selRow {
  background-color: #fbff94;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/PublicComponents/AccCode/AccCodeComponents/FilterHesabCode.vue